import React from 'react';
import { Box, Typography, Stack, Divider, Alert } from '@mui/material';
import SchoolFormFields from '../../../components/common/SchoolFormFields';
import { sa, PillButton } from '../../../components/superAdminUi';

// Step 1 of the school-edit wizard: the shared school form (URN locked/visible, Role
// autocomplete), a Load-from-GIAS refresh, the pinned duplicate/server-error alerts, and
// the separate Edit Subscription hand-off (subscription is not edited inline).
export default function SchoolDetailsStep({
  formik,
  customerTypes,
  duplicate,
  serverErrors,
  onDismissError,
  giasLoading,
  onLoadGias,
  onEditSubscription,
}) {
  const { values, errors, touched, setFieldValue } = formik;

  return (
    <Box>
      {duplicate && duplicate.isDuplicate && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          A school with this name already exists
          {duplicate.existingName ? `: ${duplicate.existingName}` : ''}.
        </Alert>
      )}

      {serverErrors.map((message, index) => (
        <Alert key={index} severity="error" sx={{ mb: 1 }} onClose={() => onDismissError(index)}>{message}</Alert>
      ))}

      <SchoolFormFields
        values={values}
        onFieldChange={(name, value) => {
          setFieldValue(name, value);
          if (name === 'Name' && serverErrors.length) onDismissError(-1);
        }}
        errors={{
          Name: touched.Name && errors.Name,
          Urn: touched.Urn && errors.Urn,
        }}
        variant="full"
        customerTypeOptions={customerTypes}
        disabledFields={{ Urn: true }}
      />

      {/* URN is locked, but the record's fields can still be refreshed from GIAS. */}
      <Box sx={{ mt: 2 }}>
        <PillButton type="button" onClick={onLoadGias} disabled={giasLoading}>
          {giasLoading ? 'Loading...' : 'Load from GIAS'}
        </PillButton>
      </Box>

      <Divider sx={{ my: 2 }} />
      <Box sx={{ p: 2, bgcolor: sa.color.page, border: `1px solid ${sa.color.stroke}`, borderRadius: sa.radius.lg }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="subtitle1" gutterBottom sx={{ fontFamily: sa.font.family, fontWeight: sa.font.bold, color: sa.color.text }}>
              Subscription Management
            </Typography>
            <Typography variant="body2" sx={{ fontFamily: sa.font.family, color: sa.color.textGray }}>
              Edit subscription details, products, pricing, and manage billing
            </Typography>
          </Box>
          <PillButton type="button" onClick={onEditSubscription}>Edit Subscription</PillButton>
        </Stack>
      </Box>
    </Box>
  );
}
